import { SaveAlt, ArrowDropDown } from '@mui/icons-material';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import React, { useState } from 'react';
import Swal from 'sweetalert2';
import dayjs from 'dayjs';
import stateList from '../../../../utils/stateList.json';

const ExportAll = (props) => {
  const { taxData,startDate,endDate,year } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const exportMapping = [
    {
      header: 'Payout Date',
      value: (row) => row.payoutDate ? `="${row.payoutDate}"` : ''
    },
    {
      header: 'Invoice No',
      value: (row) => `${row.invoiceNo}`
    },
    {
      header: 'Invoice Type',
      value: (row) => `${row.invoiceType}`
    },
    {
      header: 'Expert Name',
      value: (row) => `${row.expertName}`
    },
    {
      header: 'State Code',
      value: (row) => `${stateList.find(s => s.name === row.placeOfSupply)?.code || ''}`
    },
    {
      header: 'GSTIN (if any)',
      value: (row) => `${row.gstin || ''}`
    },
    {
      header: 'Place of Supply',
      value: (row) => `${row.placeOfSupply || ''}`
    },
    {
      header: 'Taxable Value',
      value: (row) => `${row.taxableValue}`
    },
    {
      header: 'GST Rate',
      value: (row) => {
        const rate = parseFloat(row.gstRate);
        // Check if the decimal part is not .00
        if (!isNaN(rate) && rate % 1 !== 0) {
          return `${row.gstRate}%`;
        }
        return '18%';
      }
    },
    {
      header: 'CGST',
      value: (row) => `${row.cgst}`
    },
    {
      header: 'SGST',
      value: (row) => `${row.sgst}`
    },
    {
      header: 'IGST',
      value: (row) => `${row.igst}`
    },
    {
      header: 'Total Invoice Value',
      value: (row) => `${row.totalInvoiceValue}`
    },
    {
      header: 'Service Type',
      value: (row) => `${row.serviceType || ''}`
    },
    {
      header: 'Payment Mode',
      value: (row) => `${row.paymentMode || ''}`
    },
    {
      header: 'Remarks',
      value: (row) => `${row.Remarks || ''}`
    }
  ];

  const getFileName = () =>
    `Expert_Platform_GST_Details_${dayjs(startDate).format('DD-MM-YYYY')}_to_${dayjs(endDate).format('DD-MM-YYYY')}`;

  const downloadCsv = (mapping, fileName, isOfficial = false) => {
    const exportData = taxData.map((row, index) =>
      mapping.reduce((acc, field) => {
        acc[field.header] = field.value(row, index);
        return acc;
      }, {})
    );
    const headers = mapping.map(field => `"${field.header}"`).join(',');
    const rows = exportData.map(row =>
      mapping.map(field => {
        const val = String(row[field.header] ?? '').replace(/"/g, '""');
        return `"${isOfficial && val.trim() === '' ? '-' : val}"`;
      }).join(',')
    );
    rows.unshift(headers);
    const csvString = rows.join('\n');
    const blob = new Blob(['\uFEFF', csvString], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return url;
  };

  const handleExportAllRows = async () => {
    try {
      const fileName = getFileName();
      const url = downloadCsv(exportMapping, fileName);
      Swal.fire({
        title: 'Export Successful',
        html: `<p>If download doesn't start automatically, click: <a href="${url}" download="${fileName}.csv" style="color:blue;text-decoration:underline;">Download CSV</a></p>`,
        icon: 'success', showConfirmButton: true, confirmButtonText: 'Close'
      });
    } catch (error) {
      console.error('Export failed', error);
      Swal.fire({ title: 'Export Failed', text: 'There was an issue exporting the data. Please try again.', icon: 'error' });
    }
  };

  const officialExportMapping = [
    { header: 'SL. NO.',           value: (row, i) => `${i + 1}` },
    { header: 'Branch',            value: () => 'NOIDA' },
    { header: 'Invoice Type',      value: (row) => `${row.invoiceType}` },
    { header: 'Invoice No',        value: (row) => `${row.invoiceNo}` },
    { header: 'Date',              value: (row) => row.payoutDate ? `="${dayjs(row.payoutDate).format('YYYY-MM-DD')}"` : '' },
    { header: 'State Code',        value: (row) => `${stateList.find(s => s.name === row.placeOfSupply)?.code || row.placeOfSupply || ''}` },
    { header: 'Client Name',       value: (row) => `${row.expertName}` },
    { header: 'Client GST Number', value: (row) => row.gstin ? `="${row.gstin}"` : '' },
    { header: 'Client PAN NUMBER', value: () => '' },
    { header: 'Client Adress',     value: () => '' },
    { header: 'Narration',         value: (row) => `${row.serviceType || ''}` },
    { header: 'TAXABLE',           value: (row) => `${row.taxableValue}` },
    { header: 'IGST',              value: (row) => `${row.igst}` },
    { header: 'CGST',              value: (row) => `${row.cgst}` },
    { header: 'SGST',              value: (row) => `${row.sgst}` },
    { header: 'Total GST',         value: (row) => `${row.totalInvoiceValue}` },
    { header: 'Total Amount',      value: (row) => `${row.totalInvoiceValue}` },
    { header: 'Rate',              value: (row) => {
      const rate = parseFloat(row.gstRate);
      // Check if the decimal part is not .00
      if (!isNaN(rate) && rate % 1 !== 0) {
        return `${row.gstRate}%`;
      }
      return '18%';
    }},
    { header: 'ACK',               value: () => '' },
    { header: 'IRN',               value: () => '' },
    { header: 'SAC Code',          value: () => '' },
    { header: 'Our Entity Name',   value: () => 'CuDel Delight Solutions Pvt. Ltd' },
    { header: 'Entity GST number', value: () => '09AAHCC6070E1ZP' },
    { header: 'REMARKS',           value: () => 'Expert Platform Fee Invoice' },
  ];

  const handleOfficialExport = async () => {
    try {
      const fileName = `GST-Output-Expert-Platform-${getFileName()}`;
      const url = downloadCsv(officialExportMapping, fileName, true);
      Swal.fire({
        title: 'Official Export Successful',
        html: `<p>If download doesn't start automatically, click: <a href="${url}" download="${fileName}.csv" style="color:blue;text-decoration:underline;">Download CSV</a></p>`,
        icon: 'success', showConfirmButton: true, confirmButtonText: 'Close'
      });
    } catch (error) {
      console.error('Official export failed', error);
      Swal.fire({ title: 'Export Failed', text: 'There was an issue exporting the data. Please try again.', icon: 'error' });
    }
  };

  return (
    <Box>
      <Button
        onClick={handleMenuOpen}
        startIcon={<SaveAlt />}
        endIcon={<ArrowDropDown />}
        sx={{ textTransform: 'none' }}
      >
        Export
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
        <MenuItem
          onClick={() => { handleExportAllRows(); handleMenuClose(); }}
          sx={{ fontSize: '.8rem' }}
        >
          Internal Export
        </MenuItem>
        <MenuItem
          onClick={() => { handleOfficialExport(); handleMenuClose(); }}
          sx={{ fontSize: '.8rem' }}
        >
          Official Export
        </MenuItem>
      </Menu>
    </Box>
  );
}

export default ExportAll;